module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_01_1280_1280_th-af889e4740085aced68677c7954db00c.jpg";